<template>
    <div class="row">
        <div class="col-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __("aging_parameters") }}</h4>
                    <button-open-help-modal v-if="this.tabSelected" :helpName="mainHelpName"/>
                </div>

                <div class="ibox-content">
                    <form
                        ref="form_aging_parameters"
                        class="form-group row m-b-sm"
                        :action="url"
                        method="POST"
                    >
                        <input type="hidden" name="_token" :value="csrf" />
                        <input type="hidden" name="section" :value="tab" />

                        <div class="col-md-2">
                            <label>{{ __("currency") }}*</label>
                            <select2
                                name="currency_id"
                                v-model="currency"
                                :options="currenciesSelect2"
                                :settings="{ width: '100%' }"
                            />
                        </div>

                        <div class="col-md-2">
                            <label>{{ __("aging_for_day") }}*</label>
                            <datepicker
                                ref="datepicker"
                                name="date"
                                :options="datepickerOptions"
                                :value="date ? date : currentDate"
                                :setDatepickerDate="true"
                                :initWithoutEmitEvent="true"
                                @change="onDateChange"
                            />
                        </div>
                        <div class="col-md-2" >
                           <button type="button" class="btn btn-primary m-t" v-if="visibleGenerateButton" @click="getDocuments()">
                               {{ __("generate_button") }}
                           </button>
                        </div>

                        <div class="col-md-6 text-right">
                            <a
                                href="#"
                                class="btn btn-primary m-t"
                                @click.prevent="openSetAgingRangesModal"
                            >
                                {{ __("set_the_aging_ranges") }}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
            <template v-if="documents.length != 0">
                <receivables-and-liabilities-section
                    :permission_access="permission_access"
                    :liabilities="documents.liabilities"
                    :receivables="documents.receivables"
                    :documentScanRoute="documentScanRoute"
                    :documentPdfRoute="documentPdfRoute"
                    :previewRoute="previewRoute"
                    :previewReturnRoute="previewReturnRoute"
                    :tabSelected="tab"
                    @changeTab="setTab"
                />
            </template>
        </div>

        <modal-aging-ranges
            ref="aging_ranges_modal"
            id="aging_ranges_modal"
            :title="__('set_the_aging_ranges')"
            :currency="currency"
            :date="date"
            :agingRange="agingRange"
            :helpName="helpLocalizationName + '-003'"
        />
        <help-modal/>

    </div>
</template>

<script>
import actions from "./../../vuex/action_types.js";
import { mapGetters, mapActions } from "vuex";
import ModalAgingRanges from "./../../components/modals/ModalAgingRanges";
import ReceivablesAndLiabilitiesSection from "./../../components/ReceivablesAndLiabilitiesSection";
import HelpModal from '../../components/help/HelpModal.vue';
import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue';

export default {
    name: "aging-of-receivables-and-liabilities",
    components: {
        ModalAgingRanges,
        ReceivablesAndLiabilitiesSection,
        HelpModal,
        ButtonOpenHelpModal
    },
    data: () => ({
        csrf: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        datepickerOptions: {
            todayBtn: "linked",
            format: "yyyy-mm-dd",
            todayHighlight: true,
            autoclose: true
        },
        today: new Date(),
        datePickerDate: '',
        tab: ""
    }),
    props: {
        url: String,
        currency: {
            default: 0
        },
        date: {
            default: null
        },
        intervals: {
            default: null
        },
        documents: {
            default: null
        },
        permission_access: {
            default: null
        },
        documentScanRoute: {
            type: String,
            default: "#"
        },
        documentPdfRoute: {
            type: String,
            default: "#"
        },
        previewRoute: {
            type: String,
            default: "#"
        },
        previewReturnRoute: {
            type: String,
            default: "#"
        },
        agingRange: {
            type: Object
        },
        tabSelected: {
            type: String,
            default: "receivables"
        }
    },
    computed: {
        visibleGenerateButton: function (){
            return this.isValidDateFormat(this.datePickerDate, 'YYYY-MM-DD') && this.currency != 0
        },
        currentDate: function() {
            let dd = String(this.today.getDate()).padStart(2, "0");
            let mm = String(this.today.getMonth() + 1).padStart(2, "0");
            let yyyy = this.today.getFullYear();
            return `${yyyy}-${mm}-${dd}`;
        },
        helpLocalizationName: function () { return 'ZRN' },
        mainHelpName: function () {return this.helpLocalizationName+ '-001'},
        defaultCurrencies: function() {
            return [
                { id: 0, text: "---" },
                { id: "all", text: this.__("all_currencies") }
            ];
        },
        currenciesSelect2: function() {
            return [...this.defaultCurrencies, ...this.currenciesList];
        },
        ...mapGetters({ currenciesList: "getSelect2DocumentsCurrenciesList" })
    },
    methods: {
        isValidDateFormat(dateString, dateFormat) {
            return moment(dateString, dateFormat, true).isValid();
        },
        submitForm() {
            this.$refs.form_aging_parameters.submit();
        },
        getDocuments(){
            this.submitForm();
        },
        onDateChange(val) {
            this.datePickerDate = val;
        },
        openSetAgingRangesModal() {
            this.$refs.aging_ranges_modal.openModal();
        },
        prepareDataFromArray(intervals) {
            let intervalsData = [];

            intervals.forEach((element, index) => {
                let from = element.from,
                    to = element.to,
                    fromReadonly = index == 0 ? false : true;

                intervalsData.push({
                    from: from,
                    fromReadonly: fromReadonly,
                    to: to
                });
            });

            return intervalsData;
        },
        checkIntervalsSettings() {
            if (
                (this.intervals.data[0] != undefined &&
                    this.intervals.data[0].from > this.agingRange.min) ||
                (this.intervals.data[this.intervals.data.length - 1] !=
                    undefined &&
                    this.intervals.data[this.intervals.data.length - 1].to <
                        this.agingRange.max)
            ) {
                let self = this;
                this.$swal({
                    title: self.__("warning_!"),
                    text: self.__(
                        "documents_outside_designated_ranges_will_not_be_considered"
                    ),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#55dd82",
                    confirmButtonText: self.__("ok"),
                    cancelButtonText: self.__("edit_aging_ranges"),
                    closeOnConfirm: true,
                    reverseButtons: true
                }).then(result => {
                    if (result.value == true) {
                        this.$refs.aging_ranges_modal.closeModal();
                    } else {
                        this.$refs.aging_ranges_modal.openModal();
                    }
                });
            }
        },
        setTab(val) {
            this.tab = val;
        },
        ...mapActions([
            "initIntervals",
            "saveSavedSettings",
            "saveCurrency",
            "saveDate"
        ])
    },
    created() {
        this.tab = this.tabSelected;
    },
    mounted: function() {
        this.$store.dispatch(actions.FETCH_SELECT2_DOCUMENTS_CURRENCIES_LIST);
        let savedSettings = this.intervals.saved ? true : false;
        let intervalsArray = [];
        if (this.intervals.data.length > 0) {
            intervalsArray = this.prepareDataFromArray(this.intervals.data);
        }

        this.initIntervals({
            saved: savedSettings,
            intervals: intervalsArray
        });
        this.saveCurrency(this.currency);
        this.saveDate(this.date);
        if (this.currency != 0) {
            setTimeout(() => {
                this.checkIntervalsSettings();
            }, 1000);
        }
    }
};
</script>
